/* =====================================================================
 * Auto-Geldgeschenk-Poster Editor (PROJ-41, Ja-Geldgeschenk-Familie V2)
 * =====================================================================
 * Reines Text/Bild-Poster (KEIN Foto-Upload, KEIN Crop, KEINE Map). Kopiervorlage
 * = geburtsposter.js (Geruest) + ja-geldgeschenk (Digital-Typ 3).
 *
 * PRINT-MATCH: Die Live-Vorschau spiegelt renderAutoGeldgeschenk() aus
 * citymap-server/blanket_frontend/print-mode.js 1:1 - insbesondere
 * buildAutoHtml() ist in BEIDEN Dateien identisch. Aenderungen IMMER synchron.
 *
 * Illustration (FINAL, Founder-Assets): Aquarell-Hochzeitsauto (Heckansicht,
 * Blumengirlande, Dosen an Schnueren) als transparente PNGs - Auto oben +
 * Dosen-Cluster (3/5/7) darunter, ueberlagert; die Papierfarbe scheint durch.
 * Bild-URLs kommen aus dem Theme (window.AG_ASSETS via asset_url) und werden
 * beim Cart-Add an den Server mitgeschickt (car_url/cluster_url).
 * Empfohlene Mindestgroesse 30x40 (genug Klebeflaeche fuer die Scheine).
 * ===================================================================== */

(function () {
  'use strict';

  var BACKEND_API_URL = window.AG_BACKEND_API_URL || 'https://tiles.distantlines.de';

  /* ---- Geteilte Layout-Konstanten (MUESSEN dem Server entsprechen) ---- */
  var INK = '#28292d';
  var SANS = "'Outfit', system-ui, sans-serif";
  /* Stil-Fonts Modern/Elegant/Verspielt - 1:1 vom Definitionsposter (Hauptwort).
   * MUESSEN print-mode.js entsprechen (Print-Match). Clother/Parlare via Typekit
   * sgc6idq, Playfair via Google. Parlare NUR Weight 400 (Glyphen-Bug). */
  var PW_STYLES = {
    // Weight 400 statt 700: leichter = edler (Dominik 18.07. abends)
    modern:    { font: "'clother', sans-serif",              weight: 400 },
    elegant:   { font: "'Playfair Display', Georgia, serif", weight: 400 },
    verspielt: { font: "'parlare', cursive",                 weight: 400 }
  };
  var PW_LABEL = { modern: 'Modern', elegant: 'Elegant', verspielt: 'Verspielt' };
  function pwFont(s) { return PW_STYLES[s] || PW_STYLES.elegant; }

  /* ---- Modul-State ---- */
  var root, stage, sectionId;
  var state = {
    fstyle: { names: 'verspielt' },
    names: 'Nina & Paul',
    date: '',                  // YYYY-MM-DD oder ''
    cans: 5,
    c_names: '#28292d',
    bg_color: '#ffffff',
    paper_size: '30x40',
    variant_id: '',
    product_type: '',
    frame_color: 'brown'
  };

  /* ===================================================================
   * Illustration = Aquarell-PNGs (transparent, Founder-Assets): Auto oben +
   * Dosen-Cluster (3/5/7) darunter, im 1254:1750-Rahmen ueberlagert. Die
   * transparenten PNGs lassen die Papierfarbe durch. URLs kommen aus dem
   * Theme (window.AG_ASSETS via asset_url). buildAutoHtml ist 1:1-KOPIE in
   * print-mode.js (renderAutoGeldgeschenk) - synchron halten!
   * =================================================================== */
  var AG_ASSETS = window.AG_ASSETS || {};
  function agClusterUrl(n) { return AG_ASSETS['c' + (n === 3 || n === 7 ? n : 5)] || ''; }
  function buildAutoHtml(carUrl, clusterUrl) {
    /* Beide PNGs sind vorgebackene 1254x1750-Frames (Position steckt IM Asset,
     * aus dem freigegebenen Mockup): Cluster ZUERST (liegt hinter dem Auto,
     * Schnuere kommen unter der Stossstange hervor), Auto danach obendrauf. */
    return '<div style="position:relative;width:100%;aspect-ratio:1254 / 1750;">' +
      '<img src="' + clusterUrl + '" alt="" style="position:absolute;inset:0;width:100%;height:100%;display:block;"/>' +
      '<img src="' + carUrl + '" alt="" style="position:absolute;inset:0;width:100%;height:100%;display:block;"/>' +
      '</div>';
  }

  /* ===================================================================
   * Render-Bausteine - 1:1-Spiegel von jgText/jgFit (Server print-mode.js)
   * =================================================================== */
  function agText(grid, o) {
    if (o.content == null || String(o.content).trim() === '') return null;
    var el = document.createElement('div');
    el.className = 'text-slot';
    el.textContent = o.content;
    var css = 'position:absolute;z-index:6;' +
      'left:' + (o.x != null ? o.x : 50) + '%;top:' + o.y + '%;transform:translate(-50%,-50%);' +
      'display:flex;align-items:center;justify-content:center;text-align:center;' +
      'font-family:' + o.font + ';font-weight:' + (o.weight || 400) + ';' +
      'font-size:' + o.size + 'cqw;color:' + (o.color || INK) + ';line-height:' + (o.lh || 1.15) + ';white-space:nowrap;';
    if (o.upper) css += 'text-transform:uppercase;';
    if (o.spacing) css += 'letter-spacing:' + o.spacing + ';';
    el.style.cssText = css;
    grid.appendChild(el);
    return el;
  }

  function agFit(el, maxPct) {
    if (!el) return;
    var avail = stage.clientWidth * (maxPct / 100);
    var guard = 0;
    while (el.scrollWidth > avail && guard < 40) {
      var cur = parseFloat(getComputedStyle(el).fontSize);
      if (!cur || cur < 2) break;
      el.style.fontSize = (cur * 0.96) + 'px';
      guard++;
    }
  }

  function dateLine() {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(state.date || '');
    return m ? (m[3] + '.' + m[2] + '.' + m[1]) : '';
  }

  /* ===================================================================
   * Live-Render - 1:1-Spiegel von renderAutoGeldgeschenk() (Server)
   * =================================================================== */
  function render() {
    if (!stage) return;
    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.setProperty('--blanket-color', state.bg_color);
    grid.style.backgroundColor = state.bg_color;

    // ---- Namen (Script) + Datum OBERHALB der Illustration (z-index 3, §3) ----
    var elNames = agText(grid, {
      content: (state.names || '').trim(), x: 50, y: 17.5, font: pwFont(state.fstyle.names).font, weight: pwFont(state.fstyle.names).weight,
      size: state.fstyle.names === 'verspielt' ? 8 : 9.5,  // Parlare-Grossbuchstaben riesig -> kleiner
      color: state.c_names || INK, lh: 1
    });
    if (elNames) elNames.style.zIndex = 3;
    var elDate = agText(grid, {
      content: dateLine(), x: 50, y: 24, font: SANS, weight: 500, size: 2.4,
      color: state.c_names || INK, spacing: '0.20em'
    });

    // ---- Illustration (Auto + Schnuere + Dosen) ----
    var ill = document.createElement('div');
    ill.style.cssText = 'position:absolute;left:50%;top:63%;transform:translate(-50%,-50%);width:68cqw;z-index:2;';
    ill.innerHTML = buildAutoHtml(AG_ASSETS.car || '', agClusterUrl(state.cans));
    grid.appendChild(ill);

    stage.innerHTML = '';
    stage.appendChild(grid);

    agFit(elNames, 84);
    agFit(elDate, 88);
  }

  /* ===================================================================
   * Eingaben
   * =================================================================== */
  function bindField(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.value != null) state[key] = el.value;
    el.addEventListener('input', function () { state[key] = el.value; render(); });
    el.addEventListener('change', function () { state[key] = el.value; render(); });
  }

  function initCansPicker() {
    var btns = root.querySelectorAll('.ag-cans-btn[data-cans]');
    btns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        btns.forEach(function (x) { x.classList.remove('current'); });
        b.classList.add('current');
        state.cans = parseInt(b.getAttribute('data-cans'), 10) || 5;
        render();
      });
    });
    var active = root.querySelector('.ag-cans-btn.current[data-cans]');
    if (active) state.cans = parseInt(active.getAttribute('data-cans'), 10) || 5;
  }

  function initStylePickers() {
    root.querySelectorAll('.pw-style-row[data-style-target]').forEach(function (row) {
      var target = row.getAttribute('data-style-target');
      var btns = row.querySelectorAll('.pw-style-btn[data-style]');
      var cur = row.querySelector('.pw-style-btn.current[data-style]');
      if (cur) state.fstyle[target] = cur.dataset.style;
      btns.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          btns.forEach(function (x) { x.classList.remove('current'); });
          b.classList.add('current');
          state.fstyle[target] = b.dataset.style;
          render();
        });
      });
    });
  }

  function initColorPickers() {
    root.querySelectorAll('.ag-color[data-key]').forEach(function (p) {
      if (p.value) state[p.dataset.key] = p.value;
      p.addEventListener('input', function () { state[p.dataset.key] = p.value; render(); });
    });
  }

  function initPaperColor() {
    var swatches = root.querySelectorAll('.ag-paper[data-color]');
    function setPaper(hex) {
      state.bg_color = hex;
      swatches.forEach(function (s) {
        s.classList.toggle('current', (s.getAttribute('data-color') || '').toLowerCase() === hex.toLowerCase());
      });
      render();
    }
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) { e.preventDefault(); setPaper(s.getAttribute('data-color')); });
    });
  }

  /* Info-Gluehbirne (Stadt-/Sternkarten-Muster, .tab-help) */
  function initTabHelp() {
    root.querySelectorAll('.tab-help').forEach(function (help) {
      var toggle = help.querySelector('.tab-help__toggle');
      var content = help.nextElementSibling;
      if (!toggle || !content || !content.classList.contains('tab-help__content')) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = content.style.display === 'none' || content.style.display === '';
        content.style.display = open ? 'block' : 'none';
        toggle.classList.toggle('is-active', open);
      });
      var close = content.querySelector('.tab-help__close a');
      if (close) {
        close.addEventListener('click', function (e) {
          e.preventDefault();
          content.style.display = 'none';
          toggle.classList.remove('is-active');
        });
      }
    });
  }

  /* Tabs (Design / Farben / Produkt) - main__switcher-Konvention */
  var formatDefaulted = false;
  function initTabSwitching() {
    var tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    var panels = ['text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          var el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current, fallen damit automatisch.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (nur <=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab - 1:1 Geburtsposter-/Kalender-Schema (Typ 3 = Download)
   * =================================================================== */
  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  function formatPrice(cents) {
    return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
  }
  function syncStageToSize() {
    if (!stage || !state.paper_size) return;
    var d = parsePosterDim(state.paper_size);
    var shortE = Math.min(d.w, d.h), longE = Math.max(d.w, d.h);
    stage.style.setProperty('--collage-aspect', shortE + ' / ' + longE);
    var flat = stage.closest('.ag-stage-flat');
    if (flat) flat.style.width = 'calc(min(78vh, 680px) * ' + (shortE / longE) + ')';
    render();
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('ag-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
  }
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }

  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* ===================================================================
   * Cart-Add - Muster geburtsposter.js
   * =================================================================== */
  function handleCartAdd() {
    var btn = document.getElementById('ag-cart-btn-' + sectionId);
    if (!(state.names || '').trim()) { alert('Bitte gib die Namen des Brautpaars ein.'); return; }
    if (!state.variant_id) { alert('Bitte waehle Produkt und Groesse.'); return; }
    var orig = btn ? btn.textContent : 'In den Warenkorb';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird vorbereitet...'; }

    (async function () {
      try {
        var jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
        var dim = parsePosterDim(state.paper_size);
        var shortEdge = Math.min(dim.w, dim.h), longEdge = Math.max(dim.w, dim.h);
        var dLine = dateLine();

        var payload = {
          product: 'auto-geldgeschenk',
          job_id: jobId,
          variant_id: state.variant_id,
          paper_size: state.paper_size,
          print: { width: shortEdge, height: longEdge, dpi: 300 },
          font_styles: state.fstyle,
          bg_color: state.bg_color,
          names: (state.names || '').trim(),
          date_line: dLine,
          cans: state.cans,
          car_url: AG_ASSETS.car || '',
          cluster_url: agClusterUrl(state.cans),
          c_names: state.c_names || INK
        };

        var printImageUrl = BACKEND_API_URL + '/api/v1/auto-geldgeschenk/data/' + jobId + '/';
        try {
          var renderResp = await fetch(BACKEND_API_URL + '/api/v1/auto-geldgeschenk/render/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          if (renderResp.ok || renderResp.status === 202) {
            var rd = await renderResp.json().catch(function () { return {}; });
            printImageUrl = rd.print_image_url || printImageUrl;
          }
        } catch (e) { /* Backend nicht erreichbar -> Fallback-URL bleibt */ }

        var props = {
          '_Namen': (state.names || '').trim(),
          '_Dosen': String(state.cans),
          '_job_id': jobId,
          '_print_image_url': printImageUrl,
          '_groesse': state.paper_size,
          '_Stil': PW_LABEL[state.fstyle.names] || 'Verspielt',
          '_produkt': 'auto-geldgeschenk'
        };
        if (dLine) props['_Datum'] = dLine;
        if (state.frame_color && (state.product_type || '').indexOf('Holzrahmen') !== -1) {
          props['_Frame Color'] = state.frame_color;
        }
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        var cartResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] })
        });
        if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

        var cartData = null;
        try {
          cartData = await cartResp.json();
          if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
        } catch (e) { /* skip tracking */ }

        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else window.location.href = '/cart';
      } catch (err) {
        console.error('[auto-geldgeschenk] Cart-add failed', err);
        alert('Konnte nicht in den Warenkorb legen - ' + (err.message || 'Unbekannter Fehler'));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = orig || 'In den Warenkorb'; }
      }
    })();
  }

  /* ===================================================================
   * Init - Input-Values aus dem Markup sind Source of Truth (Playbook §1)
   * =================================================================== */
  function init() {
    root = document.querySelector('.ag-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    stage = document.getElementById('ag-stage-' + sectionId);

    bindField('ag-names', 'names');
    bindField('ag-date', 'date');
    initCansPicker();
    initStylePickers();
    initColorPickers();
    initPaperColor();
    initTabHelp();
    initTabSwitching();
    initWeiterNav();
    initFormatPickers();

    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var btn = document.getElementById('ag-cart-btn-' + sectionId);
    if (btn) btn.addEventListener('click', handleCartAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
